import axios from "axios";
import { FETCH_CONVERSATIONS_SUCCESS, FETCH_CONVERSATIONS_ERROR } from "./type";
import { ITEMS_PER_PAGE } from "constants/settings";
import { CHAT_CONVERSATION } from "endpointsConst";
const URL = CHAT_CONVERSATION;
export function getConversations(lang, offset = 0) {
    return async (dispatch) => {
        try {
            const res = await axios.get(URL, {
                params: {
                    lang,
                    offset,
                    limit: ITEMS_PER_PAGE,
                },
            });
            dispatch({ type: FETCH_CONVERSATIONS_SUCCESS, payload: res.data });
        } catch (error) {
            // Не диспатчим ошибку для 401 - interceptor обработает её, обновит токен и повторит запрос
            // Если interceptor успешно повторит запрос, catch не сработает
            // Если catch сработал для 401, значит interceptor не смог обработать ошибку
            // В этом случае не нужно диспатчить ошибку, так как interceptor уже обработал её
            // Также не диспатчим ошибку, если запрос был повторен (_retry установлен)
            const isUnauthorized = error?.response?.status === 401;
            const wasRetried = error?.config?._retry;
            if (!isUnauthorized && !wasRetried) {
                dispatch({
                    type: FETCH_CONVERSATIONS_ERROR,
                    payload: error.message,
                });
            }
        }
    };
}
